module.exports = __webpack_public_path__ + "static/media/mobilepopup.e6fb8c76.jpg";